module.exports = __webpack_public_path__ + "static/media/6.5eb29806.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/6.png
// module id = 744
// module chunks = 0